export { default } from "./CancelarCategorias";
